// project imports
import {
    processEntityInput as processEntityInputMain,
    processEntityOutput as processEntityOutputMain
} from 'store/serializers/fragments/main';
import { getIriFromObj } from 'utils/processors';
import {
    processEntityInput as processEntityInputFollowUpStep,
    processEntityOutput as processEntityOutputFollowUpStep
} from 'store/app/workmgmt/followup-step';

const hasFollowUpData = (values) =>
    Boolean(values) &&
    ['@id', '@type', 'id', 'name', 'description', 'task', 'state', 'previousState', 'currentStep', 'tplReference', 'steps'].some(
        (key) => key in values
    );

export const processEntityInput = (values) => {
    if (!hasFollowUpData(values)) {
        return null;
    }

    return {
        ...values,
        ...processEntityInputMain(values),
        steps: values?.steps?.map((step) => processEntityInputFollowUpStep(step))
    };
};

export const processEntityOutput = (values) => {
    if (!hasFollowUpData(values)) {
        return undefined;
    }

    return {
        ...values,
        ...processEntityOutputMain(values),
        id: undefined,
        metadata: undefined,
        task: getIriFromObj(values?.task) || undefined,
        steps:
            'steps' in (values || {}) && Array.isArray(values.steps)
                ? values.steps.map((step) => processEntityOutputFollowUpStep({ ...step, workOrder: getIriFromObj(values) }))
                : undefined
    };
};
